export const formatLastSyncTime = (lastSyncTime: number): string => {
  const now = Date.now();
  const numMs = now - lastSyncTime;
  const numSecs = Math.round(numMs / 1000);

  if (numSecs < 5) {
    return 'just now';
  }
  if (numSecs < 30) {
    return 'a moment ago';
  }
  if (numSecs < 60) {
    return 'seconds ago';
  }

  const numMins = Math.round(numSecs / 60);
  if (numMins < 60) {
    return `${numMins} minute${numMins === 1 ? '' : 's'} ago`;
  }
  if (numMins === 60) {
    return 'an hour ago';
  }
  if (numMins > 60 && numMins < 90) {
    return 'about an hour ago';
  }

  const numHours = Math.floor(numMins / 60);
  if (numHours < 24) {
    return `${numHours} hour${numHours === 1 ? '' : 's'} ago`;
  }

  const numDays = Math.floor(numHours / 24);
  if (numDays < 30) {
    return `${numDays} day${numDays === 1 ? '' : 's'} ago`;
  }

  const numMonths = Math.floor(numDays / 30);
  if (numMonths < 12) {
    return `${numMonths} month${numMonths === 1 ? '' : 's'} ago`;
  }

  const numYears = Math.floor(numMonths / 12);
  return `${numYears} year${numYears === 1 ? '' : 's'} ago`;
};
